<div class="container">
    <br/>
    <div class="row col-xs-6">
        <form class="form-horizontal">
            <div class="form-group">
                <label for="inputName" class="col-sm-4 control-label">User Name</label>
                <div class="col-sm-8">
                    <input type="text" [(ngModel)]="name" name="name" class="form-control" id="inputName" placeholder="User Name">
                </div>
            </div>

            <div class="form-group">
                <label for="inputEmail" class="col-sm-4 control-label">Email</label>
                <div class="col-sm-8">
                    <input type="email" [(ngModel)]="email" name="email" class="form-control" id="inputEmail" placeholder="Email">
                </div>
            </div>
            <div class="form-group">
                <label for="inputPassword" class="col-sm-4 control-label">Password</label>
                <div class="col-sm-8">
                    <input type="password" [(ngModel)]="password" name="password" class="form-control" id="inputPassword" placeholder="Password">
                </div>
            </div>
            <div class="form-group">
                <label for="inputPassword2" class="col-sm-4 control-label">Confirm Password</label>
                <div class="col-sm-8">
                    <input type="password" [(ngModel)]="password2" name="password2" class="form-control" id="inputPassword2" placeholder="Confirm Password">
                </div>
            </div>
            <div *ngIf="!!error" class="login-form-button heigt30 alert-danger">
                <span class="fa fa-exclamation-triangle"></span> {{ error }}
            </div>
            <br/>

            <div class="form-group">
                <div class="col-sm-offset-2 col-sm-12">
                    <input type="button" class="btn btn-success" (click)="submit()" value="Register" />
                    <img src="/assets/images/loader.gif" *ngIf="loading">
                    <a routerLink="/login">Already regiserd? Login</a>
                </div>
            </div>
        </form>
    </div>
</div>
